// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Button, Row, Col, Icon } from 'antd';
import { UserAccessContext } from 'context/userAccess';
import Message from 'shared_components/message';
import { showMessage } from 'services/settings/message';
import TablePager from 'shared_components/table_pager';
import { fetchAgeBracketList as fetchAgeBracketListAPI, createAgeBracket, updateAgeBracket, applySorting } from 'services/settings/ageBracket';
import { getAllRangeClass } from 'services/settings/ExamItemRangeClass';
import DropDown from '../../shared/dropdown';
import DownloadCSV from 'shared_components/download_csv';
import AgeBracketTable from './table';
import FillupForm from './fillup_form';
import {
	drawerTitle,
	moduleTitle,
	buttonNames,
	tablePageSize,
	formMode,
	messagePrompts
} from '../settings';

import './index.css';

class AgeBracketDrawer extends React.Component{
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isDisplayAddForm: false,
			isDisplayUpdateForm: false,
			pageSize: tablePageSize,
			ageBrackets: [],
			selectedAgeBracket: {},
			selectedSectionId: null,
			selectedSectionName: null,
			resetSorting: false
		};

		this.addForm = React.createRef();
		this.updateForm = React.createRef();
	}

	moveRow = (dragIndex, hoverIndex) => {
		const { ageBrackets } = this.state;
		const dragRow = ageBrackets[dragIndex];
		const newData = [...ageBrackets];

		newData.splice(dragIndex, 1);
		newData.splice(hoverIndex, 0, dragRow);

		this.setState({ ageBrackets: newData, hasReordered: true });
	}

	applySort = async () => {
		const { ageBrackets } = this.state;

		const dataPayload = ageBrackets.map((rec, index) => {
			return {
				ageBracketID: rec.ageBracketID,
				ageBracketSort: index + 1,
			};
		});

		const sortResponse = await applySorting(dataPayload);
		if (sortResponse) {
			showMessage('M0003');
		}
	}

	onDblClickTableRow = (row) => {
		// Reset to original sorted order before opening drawer
		const { selectedSectionId } = this.state;
		this.setState({ isLoading: true }, async () => {
			const ageBrackets = await this.fetchAgeBracketList(selectedSectionId);
			const selectedAgeBracket = ageBrackets.find(item => item.ageBracketID === row.ageBracketID);

			this.setState({
				isDisplayUpdateForm: true,
				selectedAgeBracket,
				resetSorting: true,
				ageBrackets,
				isLoading: false
			}, () => {
				// Reset the flag after a short delay
				setTimeout(() => this.setState({ resetSorting: false }), 100);
			});
		});
	}

	onClickAdd = () => {
		// Reset to original sorted order before opening drawer
		const { selectedSectionId } = this.state;
		this.setState({ isLoading: true }, async () => {
			const ageBrackets = await this.fetchAgeBracketList(selectedSectionId);
			this.setState({
				isDisplayAddForm: true,
				resetSorting: true,
				ageBrackets,
				isLoading: false
			}, () => {
				// Reset the flag after a short delay
				setTimeout(() => this.setState({ resetSorting: false }), 100);
			});
		});
	}
	
	onChangePager = (pageSize) => {
		this.setState({ pageSize });
	}

	onDrawerClose = () => {
		const { onClose } = this.props;
		const { selectedSectionId, hasReordered } = this.state;

		// If user did drag-and-drop but didn't save, reset the data
		if (hasReordered) {
			this.setState({ isLoading: true }, async () => {
				const ageBrackets = await this.fetchAgeBracketList(selectedSectionId);
				this.setState({
					ageBrackets,
					hasReordered: false,
					isLoading: false
				});
			});
		}

		// Call parent's onClose handler
		onClose();
	}
	
	onExitAddForm = () => {
		console.log('add form did exit');
		this.addForm.current.resetForm();

		this.setState({ isDisplayAddForm: false });
	}

	onExitUpdateForm = () => {
		this.setState({ 
			isDisplayUpdateForm: false,
			selectedAgeBracket: {} 
		});
	}
	
	onSubmittingAddForm = async (fieldValues) => {
		const newFieldValues = Object.assign({}, fieldValues);
		
		const payload = {
			...newFieldValues,
			sectionID: this.state.selectedSectionId,
			ageBracketLabel: `${newFieldValues.ageBracketLabel}`.toUpperCase()
		};

		const createdItem = await createAgeBracket(payload);

		if(createdItem) {
			showMessage('M0002');
			this.addForm.current.resetForm();
		
			this.setState({ isLoading: true }, async() => {
				const { selectedSectionId } = this.state;
				const ageBrackets = await this.fetchAgeBracketList(selectedSectionId);

				this.setState({ 
					isDisplayAddForm: false, 
					isLoading: false,
					ageBrackets 
				}, () => { this.props.clearSection(); });
			});
		}
	}

	onSubmittingUpdateForm = async (fieldValues) => {
		const newFieldValues = Object.assign({}, fieldValues);
		const { selectedAgeBracket } = this.state;


		const payload = {
			...newFieldValues,
			sectionID: this.state.selectedSectionId,
			ageBracketLabel: `${newFieldValues.ageBracketLabel}`.toUpperCase(),
			ageBracketID: selectedAgeBracket.ageBracketID
		};

		const updatedItem = await updateAgeBracket(payload);

		if(updatedItem) {
			showMessage('M0003');
			this.updateForm.current.resetForm();
		
			this.setState({ isLoading: true, isDisplayUpdateForm: false }, async() => {
				const { selectedSectionId } = this.state;
				const ageBrackets = await this.fetchAgeBracketList(selectedSectionId);

				this.setState({ 
					isLoading: false,
					ageBrackets,
					selectedAgeBracket: {} 
				}, () => { this.props.clearSection(); });
			});
		}
	}
	
	onChangeSection = (sectionId, sectionName) => {
		this.setState({
			isLoading: true,
			selectedSectionId: sectionId,
			selectedSectionName: sectionName.props.children
		}, async() => {
			const ageBrackets = await this.fetchAgeBracketList(sectionId);
			// const rangeClass = await this.fetchRangeClass(sectionId);

			// Show notification if no records found
			if (ageBrackets.length === 0) {
				Message.info('No records found.');
			}

			this.setState({
				ageBrackets,
				// rangeClass,
				isLoading: false
			});
		});
	}

	// Private functions
	fetchAgeBracketList = async (selectedSectionId) => {
		const ageBrackets = await fetchAgeBracketListAPI();

		if (!ageBrackets) {
			return [];
		}

		const filtered = ageBrackets.filter(ageBracket => ageBracket.sectionID === selectedSectionId);

		// Sort by ageBracketSort in descending order (newest/highest sort value at the end)
		return filtered.sort((a, b) => (b.ageBracketSort || 0) - (a.ageBracketSort || 0));
	}


	fetchRangeClass = async (selectedSectionId) => {
		const rangeClass = await getAllRangeClass()

		return rangeClass.filter(item => item.sectionID === selectedSectionId);
	}

	render() {
		const { 
			visible, 
			onClose, 
			sectionList
		} = this.props;
			console.log("🚀 ~ AgeBracketDrawer ~ render ~ sectionList:", sectionList)

		const { 
			isDisplayAddForm, 
			isDisplayUpdateForm,
			isLoading, 
			pageSize, 
			ageBrackets,
			selectedSectionId,
			selectedSectionName,
			// rangeClass,
			selectedAgeBracket,
			hasReordered
		} = this.state;

		const isInitializing = sectionList.length === 0;

		return(
			<div>
				
				<Drawer 
					title={`${moduleTitle} - SETTINGS - AGE BRACKET`.toUpperCase()}
					width="1000"
					placement="right"
					closable
				onClose={this.onDrawerClose}
					visible={visible}
					className="ageBracket-drawer"
				>
					<section className="ageBracket-drawer-section">
						<Row style={{ marginTop: 50 }}>
							<Col span={12} offset={6}>
								<DropDown 
									label="SECTION"
									placeholder="Select Section"
									content={sectionList} 
									onChange={this.onChangeSection}
									loading={isInitializing}
									value={selectedSectionId}
								/>
							</Col>
						
						</Row>
					</section>
					<Row style={{ marginTop: 50 }}>
						<Col span={24} style={{ textAlign: 'right' }}>
							<>
								<UserAccessContext.Consumer>
									{value => value.userAccess.settings.create && (
										<>
											<DownloadCSV
												confirmRequired={true}
												isLookupTable={true}
												filename="age_brackets"
												confirmDetails={{
													title: 'AGE BRACKET',
													section: selectedSectionName || 'All',
													count: (ageBrackets || []).length,
												}}
												data={ageBrackets}
												disabled={selectedSectionId === null || (ageBrackets || []).length === 0}
												columns={[
													{ title: 'AGE BRACKET LABEL', dataIndex: 'ageBracketLabel' },
													{ 
														title: 'AGE BRACKET', 
														render: (val, record) => `${record.bracketFrom} ${record.bracketFromUnit} - ${record.bracketTo} ${record.bracketToUnit}`
													},
													{ 
														title: 'STATUS', 
														dataIndex: 'active',
														render: active => active === 0 ? 'INACTIVE' : 'ACTIVE'
													}
												]}
											/>
											<Button
												onClick={this.applySort}
												shape="round"
												type="primary"
												style={{ marginRight: 15, marginLeft: 15 }}
												disabled={selectedSectionId == null || ageBrackets.length === 0 || !hasReordered}
											>
												APPLY SORTING
											</Button>
											<Button
												shape="round"
												type="primary"
												style={{ marginRight: 10 }}
												onClick={this.onClickAdd}
												disabled={selectedSectionId == null}
											>
												<Icon type="plus" /> {buttonNames.addAgeBracket}
											</Button>
										</>
									)}
								</UserAccessContext.Consumer>
								<TablePager handleChange={this.onChangePager} />
							</>
						</Col>
					</Row>
					<AgeBracketTable
						data={ageBrackets}
						pageSize={pageSize}
						loading={isLoading}
						onRowDblClick={this.onDblClickTableRow}
						moveRow={this.moveRow}
						resetSorting={this.state.resetSorting}
					/>
				</Drawer>
				{/* ADD DRAWER */}
				<Drawer
					title={`${drawerTitle.ageBracket.add} - ${selectedSectionName}`.toUpperCase()}
					width="700"
					placement="right"
					closable
					onClose={this.onExitAddForm}
					visible={isDisplayAddForm}
					className="age-bracket-drawer"
				>
					<FillupForm 
						moduleType={formMode.add}
						onClose={this.onExitAddForm} 
						onSubmit={this.onSubmittingAddForm}
						selectedSectionName={selectedSectionName}
						selectedSectionId={selectedSectionId}
						ref={this.addForm}
					/>
				</Drawer>
				{/* UPDATE DRAWER */}
				<Drawer
					title={`${drawerTitle.ageBracket.update} - ${selectedSectionName}`.toUpperCase()}
					width="700"
					placement="right"
					closable
					onClose={this.onExitUpdateForm}
					visible={isDisplayUpdateForm}
					className="age-bracket-drawer"
				>
					<FillupForm 
						moduleType={formMode.update}
						onClose={this.onExitUpdateForm} 
						onSubmit={this.onSubmittingUpdateForm}
						ageBracket={selectedAgeBracket}
						selectedSectionName={selectedSectionName}
						ref={this.updateForm}
					/>
				</Drawer>
			</div>
		);
	}
}

AgeBracketDrawer.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	sectionList: PropTypes.array.isRequired,
	clearSection: PropTypes.func.isRequired,
};

export default AgeBracketDrawer;